import { addressSchema, vatIdSchema } from '@printdeal/address-frontend';
import { useQueryClient } from '@tanstack/react-query';
import * as yup from 'yup';

export default function useChangeAscriptionValidationSchema() {
  const queryClient = useQueryClient();

  return yup.object({
    billingAddress: addressSchema({ required: true }),
    vatId: vatIdSchema(queryClient),
    poNumber: yup.string(),
    reference: yup.string(),
  });
}

export type ChangeAscriptionFormFields = yup.InferType<ReturnType<typeof useChangeAscriptionValidationSchema>>;
